/**
 * (c) LBS logics
 *
 *     Mobile Business Technology GmbH
 *     4020 Linz, Austria
 *
 *     www.lbs-logics.com
 *
 *     created on 20190902 by Jan Brunner
 *     all rights reserved.
 */

import { Injectable } from '@angular/core';
import { IMSId } from 'src/app/_model/ims-object';
import { JobSection } from 'src/app/_model/job-section';
import { Resetable } from '../../resetter/resetable';

@Injectable()
export abstract class JobSectionsDaoService implements Resetable {
  public abstract saveJobSections(jobSections: JobSection[]): Promise<void>;
  public abstract getJobSections(): Promise<JobSection[]>;
  public abstract getJobSectionsForServiceJob(id: IMSId): Promise<JobSection[]>;
  public abstract reset(): Promise<void>;
  public abstract clear(): Promise<void>;
}